import React from 'react';
import { Link } from 'react-router-dom';

interface BrandLogoProps {
  to?: string;
  showTagline?: boolean;
  compact?: boolean;
  className?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  to = '/',
  showTagline = false,
  compact = false,
  className = '',
}) => {
  const imageClass = compact
    ? 'h-14 max-w-[190px] sm:h-16 sm:max-w-[220px]'
    : 'h-20 max-w-[240px] sm:h-24 sm:max-w-[320px]';

  const content = (
    <div className={`flex items-center ${compact ? 'gap-2' : 'gap-3'} ${className}`}>
      <img
        src="/logo_2.jpeg"
        alt="LocalAlly Main logo"
        className={`${imageClass} w-auto object-contain rounded-md border border-white/50 shadow-sm ${showTagline ? 'mb-1' : ''}`}
      />
      {showTagline && (
        <p className="text-[16px] font-medium tracking-[0.2em] text-brand-700/80">FIND • TRUST • CONNECT</p>
      )}
    </div>
  );

  return (
    <Link 
      to={to} 
      className="inline-flex items-center hover:opacity-80 focus:opacity-100 transition-opacity duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded-md"
    >
      {content}
    </Link>
  );
};

export default BrandLogo;
